export const WORKBOOK_PATHNAME = 'workbooks';
export const COLLECTIONS_PATHNAME = 'collections';
